import { ControlledSelect } from 'modules/common/components';
import Select from 'modules/common/components/Select';
import { HoldersPosition } from 'modules/donations/components/HolderPositionSelect/enum';
import { ComponentProps, FC } from 'react';
import { UseControllerProps } from 'react-hook-form';
import { getTranslation } from 'utils/getTranslation';

type Props = {
  controlled: UseControllerProps<any>;
} & ComponentProps<typeof Select>;

const t = getTranslation('donation.HolderPositionSelect');

const holderPositionOptions = Object.values(HoldersPosition).map((value) => {
  return {
    value,
    label: t(value.charAt(0).toLowerCase() + value.slice(1)),
  };
});

export const HolderPositionSelect: FC<Props> = ({
  controlled,
  ...otherProps
}) => {
  return (
    <ControlledSelect
      {...otherProps}
      options={holderPositionOptions}
      defaultValue={undefined}
      controlled={controlled}
      placeholder={t('selectHolderPosition')}
      mode="tags"
    />
  );
};
